export const coachNavItems = [
  { label: "Dashboard", icon: "icon-home", to: "/dashboard" },
  { label: "Plan", icon: "icon-star", to: "/plan" },
  { label: "Programs", icon: "icon-collection", to: "/programs" },
  { label: "Billing", icon: "icon-credit-card", to: "/billing" },
  { label: "Settings", icon: "icon-cog", to: "/settings" },
];

export const clientNavItems = [
  {
    label: "Programs",
    icon: "icon-collection",
    to: "/programs",
    subtitle: "Programs your coach has shared with you",
  },
  {
    label: "Billing",
    icon: "icon-credit-card",
    to: "/billing-settings",
    subtitle: "View your plan and billing history",
  },
  {
    label: "Settings",
    icon: "icon-cog",
    to: "/settings",
    subtitle: "Profile and password",
  },
];

export function navConfigForRole(role) {
  if (role === "coach") {
    return { navItems: coachNavItems, homeHref: "/dashboard" };
  }
  if (role === "client") {
    return { navItems: clientNavItems, homeHref: "/programs" };
  }
  return { navItems: null, homeHref: "/" };
}
